/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerSegmentsSearchQueryResponse, PntSegmentsControllerSegmentsSearchPathParams, PntSegmentsControllerSegmentsSearchQueryParams } from "../models/PntSegmentsControllerSegmentsSearch";

export function getPntSegmentsControllerSegmentsSearchUrl(slug: PntSegmentsControllerSegmentsSearchPathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/search` as const }
  return res
}

/**
 * @summary Search segment transcriptions for given terms within a date range.
 * {@link /pnt/v2/segments/:slug/search}
 */
export async function pntSegmentsControllerSegmentsSearch(slug: PntSegmentsControllerSegmentsSearchPathParams["slug"], params: PntSegmentsControllerSegmentsSearchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntSegmentsControllerSegmentsSearchQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntSegmentsControllerSegmentsSearchUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}